import { logOut } from "./authService";
import { isRateLimitError, extractRetryAfter, extractEndpoint, getRateLimitMessage } from "../utils/rateLimit";
import { getSecondsUntilExpiration, isTokenExpiredRecently } from "../utils/tokenExpiration";
import { triggerSessionWarningModal } from "../context/SessionWarningContext";

export const ErrorHandler = (error, useMessage = false) => {
	if (!error) return;
	
	// Handle rate limit errors (HTTP 429)
	if (isRateLimitError(error)) {
		const retryAfter = extractRetryAfter(error);
		const endpoint = extractEndpoint(error);
		const rateLimitInfo = getRateLimitMessage(endpoint, retryAfter);
		
		// Return object with rate limit info for components to handle
		return {
			message: rateLimitInfo.message,
			retryAfter: rateLimitInfo.retryAfter,
			isRateLimited: true,
			endpoint,
		};
	}
	
	let message = "";
	let defaultMessage = "Something went wrong, try again please.";
	if (error?.response) {
	  if (error?.response?.status > 500 && error?.response?.status < 600) {
		message = defaultMessage;
	  }
	  if (error.response.status === 401) {
		// Check if token has just expired (within warning window) before logging out
		// If token expired recently, let SessionWarningModal handle it
		// Only logout immediately if token expired a while ago (more than 1 minute)
		const WARNING_WINDOW = 60; // 60 seconds (1 minute)
		
		// First check if token is expiring soon (not yet expired)
		const secondsUntilExpiration = getSecondsUntilExpiration();
		if (secondsUntilExpiration !== null && secondsUntilExpiration <= WARNING_WINDOW && secondsUntilExpiration >= 0) {
			// Token expiring soon (within 60 seconds) - don't logout immediately
			// The SessionWarningModal should handle this
			console.log(`⚠️ 401 received but token expires in ${secondsUntilExpiration} seconds (within ${WARNING_WINDOW}s window). Letting SessionWarningModal handle it.`);
			// Don't logout immediately - modal should show if it hasn't already
			return; // Exit early, don't logout
		}
		
		// Token expired - check if it expired recently
		const expiredRecently = isTokenExpiredRecently(WARNING_WINDOW);
		if (expiredRecently === true) {
			triggerSessionWarningModal();
			return;
		} else if (expiredRecently === false) {
			logOut();
			return;
		} else {
			logOut();
			return;
		}
	  } else {
		message = error?.response?.data?.errors
		  ? Object.values(error?.response?.data?.errors)?.[0]?.[0]
		  : error?.response?.data?.validationMessages?.[0] ||
			error?.response?.data?.userMessage ||
			error?.response?.data?.message ||
			error?.response?.data?.msg ||
			error?.response?.data?.Message ||
			error?.response?.data?.error?.message ||
			error?.response?.data?.detail ||
			error?.response?.data?.error ||
			error?.response?.data?.title ||
			error?.response?.result?.message ||
			error?.response?.result?.error ||
			defaultMessage;
		if (useMessage) {
		  message = error.response.data.message || error.response.data.Message;
		}
	  }
	} else if (error?.request) {
	  message = error?.message;
	} else {
	  message = error?.message;
	}
	return message;
  };